var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"showEchart",staticClass:"showEchart"},[_c('div',{ref:"wrapper",staticClass:"wrapper",class:{
    normal:_vm.chartSize ==='normal',
    big:_vm.chartSize ==='big',
    large:_vm.chartSize === 'large'
}})])}
var staticRenderFns = []

export { render, staticRenderFns }